import Message, {MessageTypes} from '../util/message';

const MessageService = Message().init();
import phoneNumber, {phoneNumberInput} from './phoneNumber';

import { passwordStrength } from 'check-password-strength'
import {isValidPassword, validatePasswordField} from '../inc/password';
import {gtagUserLogin, userSignup} from '../inc/gtag';

const register = () => {
  const registerForm = document.querySelector('#register_form');
  const registerFormBtn = document.querySelector('.woocommerce-form-register__submit');
  const togglePasswordVisibility = document.querySelectorAll('.toggle-password-visibility');
  // const passwordField = document.querySelector('#password');
  const loginForm = document.querySelector('.login-form-ga');

  const registerFormPasswordField = document.querySelector('#register_form #password');
  const passwordErrorField = document.querySelector('#password-error');

  if (registerForm) {
    const PhoneNumber = phoneNumber();
    PhoneNumber.init();

    registerForm.addEventListener('submit', (evt) => {
      evt.preventDefault();

      document.querySelector('.woocommerce-notices-wrapper').innerHTML = '';

      const phoneErrTextContainer = document.querySelector('.phone-error');

      if (phoneNumberInput && phoneNumberInput.value && !PhoneNumber.isValidPhoneNumber()) {
        phoneNumberInput.classList.add('error');
        phoneErrTextContainer.innerText = PhoneNumber.getValidationErrorText();
        return;
      }

      if (!isValidPassword(registerFormPasswordField)) {
        return;
      }

      phoneErrTextContainer.innerText = '';
      phoneNumberInput.classList.remove('error');

      registerFormBtn.classList.add('btn--loading');

      let serializedData = jQuery(registerForm).serializeArray().reduce((acc, {name, value}) => {
        acc[name] = value;
        return acc;
      }, {});

      serializedData.tel = PhoneNumber.getPhoneWithCountryCode();

      try {
        fetch('/wp-json/wp-user/create', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(serializedData),
        })
          .then((response) => {
            return response.json();
          })
          .then((data) => {
            registerFormBtn.classList.remove('btn--loading');

            if (!data.success) {
              MessageService.displayMessage(MessageTypes.error, data.message, document.querySelector('.woocommerce-notices-wrapper'));
              return;
            }

            userSignup(serializedData, data);

            if (data.redirect) {
              window.location.href = data.redirect;
            }

          })
      } catch (err) {
        MessageService.displayMessage(MessageTypes.error, 'Something went wrong! Pls try again later.', document.querySelector('.woocommerce-notices-wrapper'));
      }
    })
  }

  if (loginForm) {
    loginForm.addEventListener('submit', () => {
      gtagUserLogin();
    });
  }

  if (togglePasswordVisibility) {
    togglePasswordVisibility.forEach((passwordVisibilityBtn) => {
      passwordVisibilityBtn.addEventListener('click', (e) => {
        e.preventDefault();

        const passwordField = passwordVisibilityBtn.parentNode.querySelector('.fitXr__input');

        const fieldType = passwordField.type === 'password' ? 'text' : 'password';

        passwordField.type = fieldType;
        passwordVisibilityBtn.classList.toggle('active');
      });
    });
  }

  validatePasswordField(registerFormPasswordField, passwordErrorField);
}

export default register;
